/* RB Cart (Oct 19, 2026): controller for sections/rb-cart.liquid, our own cart drawer that replaces the Kazam app.
   - Every cart write asks Shopify for sections=rb-cart,cart-icon-bubble and swaps #RBCart-Inner, so what the drawer
     shows is always Shopify's own server-rendered cart (prices, set discounts, codes).
   - Dawn's product form is untouched: at submit we hand it this element as its "cart" (getSectionsToRender /
     setActiveElement / renderContents), so Dawn keeps its spinner and error messages. settings.cart_type stays
     "page", so if this script (or its CSS) fails, Dawn simply goes to /cart.
   - Lines are identified by variant + properties, never by a stored key: Shopify gives a line a NEW key whenever its
     discounts change (the 2nd item turns on "סט של 2", a code applies, ...). Keys are read at send time, and a write
     that hits a stale key re-reads the cart once and retries.
   - One cart write at a time (queue). Calls window.fetch at call time on purpose: the PJ gift picker wraps fetch.
   - No requestAnimationFrame / IntersectionObserver: opening and rendering also work in background tabs.
   Public API: window.RBCart.open/close/toggle/refresh/render/add/change/applyCode/removeCode, RBCart.isOpen.
   Events on document: rb:cart:open, rb:cart:close, rb:cart:updated. Listens to cart:refresh.
   Phase-1 compat (until Kazam is uninstalled): also sets body.kazam-open and a window.KazamCart alias.
   Oct 21, 2026, sprint 2 (audit F13): [data-rb-set-one] ("עוד 1 = סט של 3 ב-₪309 + משלוח חינם") adds one more of its
   line's own item in one tap, through the same code as the line's "+" (stock limit, stale-key retry), without the
   350 ms "+" wait. Focus then lands on that line's "+". The free-delivery "hop" also stays still when the
   accessibility menu's "stop animations" is on (html.rb-a11y-motion), not only with prefers-reduced-motion.
   ShoppingIL, Nov 2026 (window.RB_SALE / window.RB_PO from the layouts, texts from snippets/rb-po; with the sale at 0%
   and pre-order off nothing here changes what the drawer does):
   - Pre-order: every add from the drawer (suggestion cards, the set picker) sends the line property "הזמנה מוקדמת" for a
     variant whose JSON has "p":1. A size/colour swap on a line adds the property when the new variant is pre-order
     and drops it when it isn't. "+", "−" and the "1 more" hint change the line itself, so its property stays.
   - The order note "משלוח" (mixed carts): after every repaint (and on page load) syncShipAttr() compares the cart's
     value with what it should be (the hidden [data-rb-po-attr] input, server-rendered) and posts /cart/update.js only
     when they differ and that value isn't already on its way; no repaint follows, so no loop. On /cart (Dawn's cart.js
     owns that page) the same check runs on load and after Dawn repaints the items (MutationObserver).
   - While the sale is on, the WELCOME30 "applies by itself over ₪300" message and pending pill are off: the code doesn't
     combine with the sale, so Shopify would never apply it. */
(function () {
  // Not window.RBCart: that name would also match an element with that id (named window access).
  if (window.__rbCartLoaded) return;
  window.__rbCartLoaded = true;

  var SECTIONS = 'rb-cart,cart-icon-bubble';
  var R = window.routes || {};
  var U = {
    add: (R.cart_add_url || '/cart/add') + '.js',
    change: (R.cart_change_url || '/cart/change') + '.js',
    update: (R.cart_update_url || '/cart/update') + '.js',
    cart: R.cart_url || '/cart'
  };
  var ROOT_URL = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var PENDING_KEY = 'rb_cart_code_pending';
  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  // read at use time: the accessibility menu can switch "stop animations" on after this script ran
  function calm() { return reduce || document.documentElement.classList.contains('rb-a11y-motion'); }
  var S = {};
  var isOpen = false, lastFocus = null, activeEl = null, closeTimer = 0, stale = false, hiddenAt = 0;
  var chain = Promise.resolve(), busy = 0, pendingQty = {}, qtyTimers = {}, noteTimer = 0, alertTimer = 0;
  var checkoutPending = false, focusAfter = null;
  var setPending = {}, setFresh = false;   // set picker: adds in flight (by product id); start fresh after its own add

  function root() { return document.getElementById('rb-cart-root'); }
  function q(sel, ctx) { var c = ctx || root(); return c ? c.querySelector(sel) : null; }
  function qa(sel, ctx) { var c = ctx || root(); return c ? Array.prototype.slice.call(c.querySelectorAll(sel)) : []; }
  function isPage() { var r = root(); return !r || r.hasAttribute('data-page-cart'); }
  function emit(name, detail) { document.dispatchEvent(new CustomEvent(name, { detail: detail || {} })); }
  function ss(k, v) {
    try { if (v === undefined) return sessionStorage.getItem(k); if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v); } catch (e) {}
    return null;
  }
  function focusEl(el) { if (!el) return; try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); } }
  // ShoppingIL (Nov 2026): read at use time from the layouts' globals
  function saleOn() { return !!(window.RB_SALE && Number(window.RB_SALE.pct) > 0); }
  function poOn() { var p = window.RB_PO; return !!(p && p.on && p.key); }
  function poProps() { var o = {}; o[window.RB_PO.key] = window.RB_PO.val; return o; }

  function post(url, body) {
    return window.fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) { j = j || {}; j.httpStatus = r.status; throw j; } return j; });
    });
  }
  function getCart() {
    return window.fetch(U.cart + '.js', { cache: 'no-store', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function getSections() {
    return window.fetch(ROOT_URL + '?sections=' + SECTIONS, { cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw { description: S.err }; return r.json(); });
  }
  function withSections(b) { b.sections = SECTIONS; b.sections_url = location.pathname; return b; }
  // One cart write at a time, in order (fast taps, code + qty, ...). Never call queue() from inside a queued fn.
  function queue(fn) {
    busy++; setBusy();
    var p = chain.then(fn);
    chain = p.catch(function () {}).then(function () { busy--; setBusy(); });
    return p;
  }
  function setBusy() { var r = root(); if (r) r.classList.toggle('is-busy', busy > 0); }

  // The newest message wins: the set adds say "updated" (repaint) and then "added to your set" right after, and a
  // screen reader should hear only the second (review, Oct 21, 2026, sprint 2).
  var sayTimer = 0;
  function say(text) {
    var st = document.getElementById('RBCart-Status');
    if (!st || !text) return;
    st.textContent = '';
    clearTimeout(sayTimer);
    sayTimer = setTimeout(function () { st.textContent = text; }, 120);
  }
  function showAlert(text) {
    var a = document.getElementById('RBCart-Alert');
    if (!a) return;
    a.textContent = text || S.err;
    a.hidden = false;
    clearTimeout(alertTimer);
    alertTimer = setTimeout(function () { a.hidden = true; }, 6000);
  }
  function msg(el, text, ok) {
    if (!el) return;
    el.textContent = text || '';
    el.hidden = !text;
    el.classList.toggle('is-ok', !!ok);
  }
  function fail(e) {
    var text = e && e.description;
    return refresh().then(function () { showAlert(text); });
  }

  /* ---------- lines ---------- */
  function ident(li) { return li.getAttribute('data-variant') + '|' + (li.getAttribute('data-props') || '{}'); }
  function lineEl(id, ctx) {
    return qa('.rb-cart__line', ctx).filter(function (l) { return ident(l) === id; })[0] || null;
  }
  function keyOf(id) { var li = lineEl(id); return li ? li.getAttribute('data-key') : null; }
  function propsOf(li) {
    var p = null;
    try { p = JSON.parse(li.getAttribute('data-props') || 'null'); } catch (e) {}
    if (!p || typeof p !== 'object' || Array.isArray(p) || !Object.keys(p).length) return null;
    return p;
  }
  // ShoppingIL (Nov 2026): find a line by variant + properties after a swap changed its properties (the pre-order one):
  // the server's data-props string can't be rebuilt byte for byte here, so compare the parsed objects.
  function sameProps(a, b) {
    a = a || {}; b = b || {};
    var ka = Object.keys(a), kb = Object.keys(b);
    return ka.length === kb.length && ka.every(function (k) { return Object.prototype.hasOwnProperty.call(b, k) && String(a[k]) === String(b[k]); });
  }
  function lineFor(variantId, props) {
    return qa('.rb-cart__line').filter(function (l) {
      return Number(l.getAttribute('data-variant')) === variantId && sameProps(propsOf(l), props);
    })[0] || null;
  }
  function keyInSections(sections, id) {
    if (!sections || !sections['rb-cart']) return null;
    var doc = new DOMParser().parseFromString(sections['rb-cart'], 'text/html');
    var li = lineEl(id, doc);
    return li ? li.getAttribute('data-key') : null;
  }
  // Change a line's quantity (0 = remove) by identity. Runs INSIDE a queued fn. If the key went stale because a write
  // outside this drawer (product page add, set picker, gift picker, another tab) changed the line's discounts, re-read
  // the cart once and retry with the fresh key.
  function changeLine(id, qty) {
    var key = keyOf(id);
    if (!key) return Promise.reject({ description: S.err });
    return post(U.change, withSections({ id: key, quantity: qty })).catch(function (e) {
      if (!e || (e.httpStatus !== 400 && e.httpStatus !== 422)) throw e;
      return getSections().then(function (sec) {
        var fresh = keyInSections(sec, id);
        if (!fresh || fresh === key) throw e;
        return post(U.change, withSections({ id: fresh, quantity: qty }));
      });
    });
  }

  /* ---------- ShoppingIL (Nov 2026): the order note "משלוח" on mixed carts ----------
     The server renders [data-rb-po-attr] (drawer form or the /cart form) only while pre-order is on: value = what the
     note should be ("כל ההזמנה יוצאת יחד עד 24.11", or "" to clear it), data-have = what the cart has. Post only when
     they differ and that exact value isn't already on its way (attrSent); the post asks for no sections, so nothing
     repaints and nothing loops. attrSent clears once a fresh render shows the cart has it, or when the post fails. */
  var attrSent = null;
  function syncShipAttr() {
    if (!poOn() || !window.RB_PO.attrKey) return;
    var el = document.querySelector('[data-rb-po-attr]');
    if (!el) return;
    var want = el.value || '', have = el.getAttribute('data-have') || '';
    if (attrSent !== null && have === attrSent) attrSent = null;
    if (want === have || want === attrSent) return;
    attrSent = want;
    var a = {}; a[window.RB_PO.attrKey] = want;
    queue(function () { return post(U.update, { attributes: a }); }).then(function () {
      var e2 = document.querySelector('[data-rb-po-attr]');
      if (e2 && e2.value === want) e2.setAttribute('data-have', want);
    }, function () { if (attrSent === want) attrSent = null; });
  }
  // /cart: Dawn's cart.js repaints the items (and this form's input) after each change; check again after that.
  function watchPage() {
    var box = document.getElementById('main-cart-items');
    if (!box || !poOn() || !window.MutationObserver) return;
    var t = 0;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(syncShipAttr, 60); })
      .observe(box, { childList: true, subtree: true });
  }

  /* ---------- render ---------- */
  function snapshot() {
    var snap = { boxes: [], focus: null, code: '', note: null, noteSel: null, scroll: 0, scrollX: 0 };
    var sc = q('.rb-cart__scroll'); if (sc) snap.scroll = sc.scrollTop;
    var tx = q('.rb-cart__cards'); if (tx) snap.scrollX = tx.scrollLeft;
    qa('[data-rb-box]').forEach(function (b) { if (!b.hidden) snap.boxes.push(b.id); });
    var code = document.getElementById('RBCart-Code'); if (code) snap.code = code.value;
    var note = document.getElementById('RBCart-Note');
    var a = document.activeElement;
    if (note && a === note) { snap.note = note.value; snap.noteSel = [note.selectionStart, note.selectionEnd]; }
    if (a && root() && root().contains(a)) snap.focus = a.getAttribute('data-rb-focus') || (a.classList.contains('rb-cart__panel') ? 'panel' : null);
    // the set picker's size/colour choices (a repaint would put them back on the line's own variant)
    snap.sopt = {};
    qa('select[data-rb-sopt]').forEach(function (s) { var k = s.getAttribute('data-rb-focus'); if (k) snap.sopt[k] = s.value; });
    return snap;
  }
  function restore(snap) {
    var sc = q('.rb-cart__scroll'); if (sc) sc.scrollTop = snap.scroll;
    var tx = q('.rb-cart__cards'); if (tx) tx.scrollLeft = snap.scrollX;
    snap.boxes.forEach(function (id) {
      var b = document.getElementById(id); if (!b) return;
      b.hidden = false;
      var t = q('[aria-controls="' + id + '"]'); if (t) t.setAttribute('aria-expanded', 'true');
    });
    var code = document.getElementById('RBCart-Code'); if (code && snap.code) code.value = snap.code;
    var note = document.getElementById('RBCart-Note');
    if (note && snap.note !== null) note.value = snap.note;
    Object.keys(pendingQty).forEach(function (k) { var li = lineEl(k); if (li) showQty(li, pendingQty[k]); });
    if (setFresh) setFresh = false;
    else Object.keys(snap.sopt || {}).forEach(function (k) {
      var s = q('select[data-rb-focus="' + k + '"]'), val = snap.sopt[k];
      if (s && Array.prototype.some.call(s.options, function (o) { return o.value === val; })) s.value = val;
    });
    if (!isOpen) return;
    var el = null, moved = false;
    if (focusAfter) { el = focusAfter(); focusAfter = null; moved = !!el; }
    if (!el && snap.focus && snap.focus !== 'panel') {
      el = q('[data-rb-focus="' + snap.focus.replace(/"/g, '\\"') + '"]');
      if (!el) {
        var m = /^(dn|up|rm|opt):(\d+)/.exec(snap.focus);
        var rms = qa('[data-rb-focus^="rm:"]');
        if (m && rms.length) el = q('[data-rb-focus="rm:' + Math.min(Number(m[2]), rms.length) + '"]');
        else if (/^pill:/.test(snap.focus)) el = q('[data-rb-focus="tog:code"]');
        // the set hint is gone once the set is complete: land on that product's "+" (same as the set picker)
        else if (/^(setone|set):/.test(snap.focus)) el = q('.rb-cart__line[data-product="' + snap.focus.split(':')[1].replace(/\D/g, '') + '"] [data-rb-qty="1"]');
        else if (/^(card|cardopt):/.test(snap.focus)) el = q('[data-rb-card] [data-rb-upsell-add]') || q('.rb-cart__checkout');
      }
    }
    if (!el && snap.focus) el = q('.rb-cart__close') || q('.rb-cart__panel');
    if (el) {
      focusEl(el);
      if (moved) {
        var vis = el.closest('[data-rb-setbox]') || el.closest('.rb-cart__line') || el;
        try { vis.scrollIntoView({ block: 'nearest' }); } catch (e) { try { vis.scrollIntoView(false); } catch (e2) {} }
      }
      if (el === note && snap.noteSel) { try { note.setSelectionRange(snap.noteSel[0], snap.noteSel[1]); } catch (e) {} }
    }
  }
  function paint(sections, opts) {
    opts = opts || {};
    var r = root();
    if (!r) return;
    if (!sections || !sections['rb-cart']) { if (!opts.noRefetch) refresh(); return; }
    var doc = new DOMParser().parseFromString(sections['rb-cart'], 'text/html');
    var nr = doc.getElementById('rb-cart-root'), ni = doc.getElementById('RBCart-Inner'), inner = q('#RBCart-Inner');
    if (nr && ni && inner) {
      var snap = snapshot();
      var wasOn = r.getAttribute('data-unlocked') === 'true';
      inner.innerHTML = ni.innerHTML;
      ['data-count', 'data-subtotal', 'data-codes', 'data-unlocked', 'data-upsell-attr'].forEach(function (a) {
        r.setAttribute(a, nr.getAttribute(a) || '');
      });
      pendingPill();
      restore(snap);
      focusAfter = null;   // one-shot, even when the drawer was closed and restore() didn't use it
      decorateAll();
      arrows();
      if (checkoutPending) { var cb = q('.rb-cart__checkout'); if (cb) cb.setAttribute('aria-busy', 'true'); }
      // Nov 2, 2026: .is-celebrate has no style any more (no truck hop, no glow: assets/rb-cart.css); kept as a hook
      if (!wasOn && r.getAttribute('data-unlocked') === 'true' && isOpen && !calm()) {
        var ship = q('.rb-cart__ship');
        if (ship) { ship.classList.add('is-celebrate'); setTimeout(function () { ship.classList.remove('is-celebrate'); }, 1400); }
      }
    }
    var icon = document.getElementById('cart-icon-bubble');
    if (icon && sections['cart-icon-bubble']) {
      var d2 = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
      var src = d2.querySelector('.shopify-section');
      if (src) icon.innerHTML = src.innerHTML;
    }
    if (opts.status) say(opts.status);
    emit('rb:cart:updated', { source: opts.source || '' });
    syncShipAttr();   // ShoppingIL (Nov 2026): mixed-cart order note
  }

  /* ---------- open / close ---------- */
  function onKey(e) {
    var html = document.documentElement;
    if (!isOpen || html.classList.contains('rb-gift-lock') || html.classList.contains('rb-pop-lock')) return;
    var panel = q('.rb-cart__panel');
    if (!panel) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    var f = qa('a[href], button:not([disabled]), select:not([disabled]), textarea, input:not([type="hidden"])', panel)
      .filter(function (el) { return el.offsetParent !== null && !el.closest('[hidden]'); });
    if (!f.length) { e.preventDefault(); panel.focus(); return; }
    var first = f[0], last = f[f.length - 1], a = document.activeElement;
    if (!panel.contains(a)) { e.preventDefault(); first.focus(); return; }
    if (e.shiftKey && (a === first || a === panel)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && a === last) { e.preventDefault(); first.focus(); }
  }
  function setIcon(expanded) {
    var icon = document.getElementById('cart-icon-bubble');
    if (icon) icon.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  }
  function styled(r) {
    // rb-cart.css loads without blocking the page; if it isn't there yet, use the cart page instead of an unstyled drawer.
    try { return getComputedStyle(r).position === 'fixed'; } catch (e) { return true; }
  }
  function open(trigger) {
    var r = root();
    if (!r) return Promise.resolve();
    if (isPage()) {
      var m = document.getElementById('MainContent');
      if (m) m.scrollIntoView({ behavior: calm() ? 'auto' : 'smooth' });
      return Promise.resolve();
    }
    clearTimeout(closeTimer);
    var was = isOpen;
    if (!was) lastFocus = trigger || activeEl || document.activeElement;
    r.hidden = false;
    if (!styled(r)) { r.hidden = true; window.location.href = U.cart; return Promise.resolve(); }
    void r.offsetWidth;
    r.classList.add('is-open');
    isOpen = true;
    if (!was) {
      document.documentElement.classList.add('rb-cart-lock');
      document.body.classList.add('rb-cart-open', 'kazam-open');
      setIcon(true);
      focusEl(q('.rb-cart__panel'));
      document.removeEventListener('keydown', onKey);
      document.addEventListener('keydown', onKey);
      emit('rb:cart:open');
    }
    arrows();
    if (stale) return refresh();
    return Promise.resolve();
  }
  function close() {
    var r = root();
    if (!r || !isOpen) return;
    isOpen = false;
    r.classList.remove('is-open');
    document.documentElement.classList.remove('rb-cart-lock');
    document.body.classList.remove('rb-cart-open', 'kazam-open');
    setIcon(false);
    document.removeEventListener('keydown', onKey);
    closeTimer = setTimeout(function () { if (!isOpen) r.hidden = true; }, reduce ? 0 : 340);
    var lf = lastFocus;
    lastFocus = null; activeEl = null;
    if (lf && lf.isConnected && lf.focus) focusEl(lf);
    emit('rb:cart:close');
  }

  /* ---------- cart actions ---------- */
  function refresh(opts) {
    opts = opts || {};
    if (isPage()) { location.reload(); return Promise.resolve(); }
    return queue(getSections).then(function (sections) {
      paint(sections, { source: opts.source || 'refresh', noRefetch: true });
      stale = false;
      if (opts.open) return open();
    }, function () {
      qa('.rb-cart__line.is-busy').forEach(function (l) { l.classList.remove('is-busy'); });
      if (opts.open) return open();
    });
  }
  function add(items, opts) {
    opts = opts || {};
    return queue(function () { return post(U.add, withSections({ items: items })); })
      .then(function (res) {
        if (opts.focusAfter) focusAfter = opts.focusAfter;
        if (opts.fresh) setFresh = true;
        paint(res.sections, { status: S.added, source: opts.source || 'add' });
        if (opts.open !== false) open(opts.trigger);
        return res;
      });
  }
  function change(key, qty) {
    return queue(function () { return post(U.change, withSections({ id: key, quantity: qty })); })
      .then(function (cart) { paint(cart.sections, { status: qty ? S.updated : S.removed, source: 'change' }); return cart; });
  }

  function maxOf(li) { var m = li.getAttribute('data-max'); return m === '' || m === null ? Infinity : Number(m); }
  function setDis(btn, off) { if (!btn) return; if (off) btn.setAttribute('aria-disabled', 'true'); else btn.removeAttribute('aria-disabled'); }
  function showQty(li, n) {
    var max = maxOf(li);
    var num = q('.rb-cart__qty-n', li); if (num) num.textContent = n;
    // aria-disabled, not disabled: the button keeps keyboard focus at 1 / at the stock limit.
    setDis(q('[data-rb-qty="-1"]', li), n <= 1);
    setDis(q('[data-rb-qty="1"]', li), n >= max);
  }
  function setQty(id, delta) {
    var li = lineEl(id);
    if (!li) return;
    var cur = pendingQty[id] != null ? pendingQty[id] : Number(li.getAttribute('data-qty'));
    var max = maxOf(li);
    var next = Math.max(1, Math.min(max, cur + delta));
    if (next === cur) {
      if (delta > 0 && max !== Infinity) msg(q('[data-rb-line-err]', li), S.max.replace('[n]', max));
      return;
    }
    msg(q('[data-rb-line-err]', li), '');
    pendingQty[id] = next;
    showQty(li, next);
    clearTimeout(qtyTimers[id]);
    qtyTimers[id] = setTimeout(function () { sendQty(id); }, 350);
  }
  function sendQty(id) {
    var want = pendingQty[id];
    if (want == null) return Promise.resolve();
    var li = lineEl(id); if (li) li.classList.add('is-busy');
    return queue(function () { return changeLine(id, want); }).then(function (cart) {
      if (pendingQty[id] === want) delete pendingQty[id];
      paint(cart.sections, { status: S.updated, source: 'qty' });
      var l2 = lineEl(id);
      if (l2 && Number(l2.getAttribute('data-qty')) < want) msg(q('[data-rb-line-err]', l2), S.max.replace('[n]', l2.getAttribute('data-qty')));
    }, function (e) { delete pendingQty[id]; return fail(e); });
  }
  function removeLine(id) {
    var li = lineEl(id); if (li) li.classList.add('is-busy');
    delete pendingQty[id]; clearTimeout(qtyTimers[id]);
    return queue(function () { return changeLine(id, 0); })
      .then(function (cart) { paint(cart.sections, { status: S.removed, source: 'remove' }); }, fail);
  }

  /* ---------- variants (line size/colour change + suggestion cards) ---------- */
  function variantsOf(box) {
    var el = q('script[data-rb-variants]', box);
    if (!el) return null;
    if (!el._v) { try { el._v = JSON.parse(el.textContent); } catch (e) { el._v = []; } }
    return el._v;
  }
  function selectsOf(box) { return qa('select[data-rb-opt]', box); }
  function pick(vs, sels, base) {
    var o = (base || [null, null, null]).slice();
    sels.forEach(function (s) { o[Number(s.getAttribute('data-rb-opt'))] = s.value; });
    return vs.filter(function (v) {
      return sels.every(function (s) { var i = Number(s.getAttribute('data-rb-opt')); return v.o[i] === o[i]; });
    })[0] || null;
  }
  function decorate(box) {
    var vs = variantsOf(box);
    if (!vs) return;
    var sels = selectsOf(box);
    sels.forEach(function (s) {
      var i = Number(s.getAttribute('data-rb-opt')), isSize = s.hasAttribute('data-rb-size');
      Array.prototype.forEach.call(s.options, function (op) {
        if (!op.value) return;
        var ok = vs.some(function (v) {
          if (!v.a || v.o[i] !== op.value) return false;
          if (isSize) return true;
          return sels.every(function (s2) {
            var j = Number(s2.getAttribute('data-rb-opt'));
            if (j === i || !s2.value || !s2.hasAttribute('data-rb-size')) return true;
            return v.o[j] === s2.value;
          });
        });
        var label = op.getAttribute('data-l') || op.value;
        op.textContent = ok ? label : label + S.soldSuffix;
        op.disabled = !ok && !op.selected;
      });
    });
  }
  // Suggestion cards: non-size options start on the first value that's in stock (in the chosen size, if any).
  function settleCard(card) {
    var vs = variantsOf(card);
    if (!vs) return;
    var sels = selectsOf(card);
    var size = sels.filter(function (s) { return s.hasAttribute('data-rb-size'); })[0];
    sels.forEach(function (s) {
      if (s === size) return;
      var i = Number(s.getAttribute('data-rb-opt'));
      var okFor = function (val) {
        return vs.some(function (v) {
          return v.a && v.o[i] === val && (!size || !size.value || v.o[Number(size.getAttribute('data-rb-opt'))] === size.value);
        });
      };
      if (okFor(s.value)) return;
      var first = Array.prototype.filter.call(s.options, function (op) { return op.value && okFor(op.value); })[0];
      if (first) s.value = first.value;
    });
    decorate(card);
  }
  function decorateAll() {
    qa('.rb-cart__line').forEach(decorate);
    qa('[data-rb-card]').forEach(function (c) { if (variantsOf(c)) settleCard(c); });
    qa('[data-rb-setbox]').forEach(decorateSet);
    qa('[data-rb-set-add]').forEach(function (b) {
      var on = !!setPending[b.getAttribute('data-product')];
      b.disabled = on; b.classList.toggle('is-loading', on);
    });
  }
  function currentOptions(li) {
    var vs = variantsOf(li) || [];
    var id = Number(li.getAttribute('data-variant'));
    var v = vs.filter(function (x) { return x.id === id; })[0];
    return v ? v.o : [null, null, null];
  }
  function qtyInCart(variantId) {
    return qa('.rb-cart__line').reduce(function (n, l) {
      return n + (Number(l.getAttribute('data-variant')) === variantId ? Number(l.getAttribute('data-qty')) || 0 : 0);
    }, 0);
  }
  function swapVariant(li, sel) {
    var vs = variantsOf(li);
    if (!vs) return;
    var err = q('[data-rb-line-err]', li);
    var sels = selectsOf(li);
    var base = currentOptions(li);
    var revert = function (text) {
      sels.forEach(function (s) { s.value = base[Number(s.getAttribute('data-rb-opt'))]; });
      decorate(li);
      msg(err, text);
    };
    var v = pick(vs, sels, base);
    if (!v || !v.a) {
      // Keep the shopper's change; move the other options to the closest variant that's in stock.
      var o = base.slice();
      sels.forEach(function (s) { o[Number(s.getAttribute('data-rb-opt'))] = s.value; });
      var changed = Number(sel.getAttribute('data-rb-opt'));
      v = vs.filter(function (x) { return x.a && x.o[changed] === o[changed]; }).sort(function (a, b) {
        var sa = 0, sb = 0;
        sels.forEach(function (s) { var i = Number(s.getAttribute('data-rb-opt')); if (a.o[i] === o[i]) sa++; if (b.o[i] === o[i]) sb++; });
        return sb - sa;
      })[0] || null;
    }
    if (!v) { revert(S.soldOpt); return; }
    if (v.id === Number(li.getAttribute('data-variant'))) { decorate(li); return; }
    var id = ident(li);
    var qty = pendingQty[id] != null ? pendingQty[id] : (Number(li.getAttribute('data-qty')) || 1);
    // Never ask for more than the new variant has left (Shopify would add part of it AND report an error).
    var cap = v.q == null ? Infinity : v.q - qtyInCart(v.id);
    if (cap <= 0) { revert(S.soldOpt); return; }
    var note = '';
    if (cap < qty) { qty = cap; note = S.max.replace('[n]', cap); }
    var props = propsOf(li);
    // ShoppingIL (Nov 2026): the NEW variant decides the pre-order property ("p":1 in the JSON), not the old line
    var poMoved = false;
    if (poOn()) {
      var pk = window.RB_PO.key, had = !!(props && props[pk] != null);
      if (v.p && !had) { props = props || {}; props[pk] = window.RB_PO.val; poMoved = true; }
      else if (!v.p && had) { delete props[pk]; if (!Object.keys(props).length) props = null; poMoved = true; }
    }
    var item = { id: v.id, quantity: qty };
    if (props) item.properties = props;
    var newId = v.id + '|' + (li.getAttribute('data-props') || '{}');
    var optIdx = sel.getAttribute('data-rb-opt');
    var targetBefore = qtyInCart(v.id);
    msg(err, '');
    delete pendingQty[id]; clearTimeout(qtyTimers[id]);
    li.classList.add('is-busy');
    sels.forEach(function (s) { s.disabled = true; });   // no second change while this one runs
    // Add the new variant first, then remove the old line by its key AFTER the add (the add usually changes the set
    // discount, which re-keys the old line). A failed add changes nothing.
    queue(function () {
      if (!keyOf(id)) throw { description: S.err };
      return post(U.add, withSections({ items: [item] })).then(function (res) {
        var k = keyInSections(res.sections, id);
        if (!k) return res;
        return post(U.change, withSections({ id: k, quantity: 0 }));
      }, function (e) {
        // Out of stock mid-way: Shopify may have added part of it. If the new variant did go up, finish the swap.
        return getCart().then(function (cart) {
          var now = cart.items.filter(function (i) { return i.variant_id === v.id; }).reduce(function (n, i) { return n + i.quantity; }, 0);
          if (now <= targetBefore) throw e;
          note = S.max.replace('[n]', now - targetBefore);
          return getSections().then(function (sec) {
            var k = keyInSections(sec, id);
            if (!k) return sec;
            return post(U.change, withSections({ id: k, quantity: 0 }));
          });
        });
      });
    }).then(function (res) {
      focusAfter = function () {
        var nl = poMoved ? lineFor(v.id, props) : lineEl(newId);
        if (nl && note) msg(q('[data-rb-line-err]', nl), note);
        return nl ? q('select[data-rb-opt="' + optIdx + '"]', nl) : null;
      };
      paint(res.sections || res, { status: S.updated, source: 'variant' });
    }, fail);
  }

  /* ---------- set picker: "1 more for a set" adds the next item of the same product in any size/colour ----------
     Its own attribute (data-rb-sopt), so the line's own size/colour selects and swapVariant never see these. */
  function setVariants(box) {
    var el = q('script[data-rb-svariants]', box);
    if (!el) return [];
    if (!el._v) { try { el._v = JSON.parse(el.textContent); } catch (e) { el._v = []; } }
    return el._v;
  }
  function setSels(box) { return qa('select[data-rb-sopt]', box); }
  function setPick(box) {
    var vs = setVariants(box), sels = setSels(box);
    if (!sels.length) return vs.filter(function (v) { return v.a; })[0] || vs[0] || null;
    return vs.filter(function (v) {
      return sels.every(function (s) { return v.o[Number(s.getAttribute('data-rb-sopt'))] === s.value; });
    })[0] || null;
  }
  // Same rule as the line selects: sizes show "sold out" only when no colour has them; other options are checked
  // against the chosen size.
  function decorateSet(box) {
    var vs = setVariants(box), sels = setSels(box);
    sels.forEach(function (s) {
      var i = Number(s.getAttribute('data-rb-sopt')), isSize = s.hasAttribute('data-rb-size');
      Array.prototype.forEach.call(s.options, function (op) {
        var ok = vs.some(function (v) {
          if (!v.a || v.o[i] !== op.value) return false;
          if (isSize) return true;
          return sels.every(function (s2) {
            var j = Number(s2.getAttribute('data-rb-sopt'));
            return j === i || !s2.hasAttribute('data-rb-size') || v.o[j] === s2.value;
          });
        });
        var label = op.getAttribute('data-l') || op.value;
        op.textContent = ok ? label : label + S.soldSuffix;
        op.disabled = !ok && !op.selected;
      });
    });
  }
  // A new size can leave the colour on something that size doesn't have: move it to the first colour that's in stock.
  function settleSet(box, changed) {
    var vs = setVariants(box), sels = setSels(box);
    if (changed && changed.hasAttribute('data-rb-size')) {
      var si = Number(changed.getAttribute('data-rb-sopt'));
      sels.forEach(function (s) {
        if (s === changed) return;
        var i = Number(s.getAttribute('data-rb-sopt'));
        var okFor = function (val) { return vs.some(function (v) { return v.a && v.o[i] === val && v.o[si] === changed.value; }); };
        if (okFor(s.value)) return;
        var first = Array.prototype.filter.call(s.options, function (op) { return okFor(op.value); })[0];
        if (first) s.value = first.value;
      });
    }
    decorateSet(box);
  }
  function setAdd(btn) {
    var box = btn.closest('[data-rb-setbox]');
    if (!box) return;
    var err = q('[data-rb-set-err]', box);
    var v = setPick(box);
    if (!v || !v.a) { msg(err, S.soldOpt); return; }
    if (v.q != null && v.q - qtyInCart(v.id) <= 0) { msg(err, S.max.replace('[n]', Math.max(0, v.q))); return; }
    var pid = btn.getAttribute('data-product');
    if (setPending[pid]) return;   // one at a time: a repaint in between must not allow a second add
    msg(err, '');
    setPending[pid] = true;
    btn.disabled = true;
    btn.classList.add('is-loading');
    var it = { id: v.id, quantity: 1 };
    if (v.p && poOn()) it.properties = poProps();   // ShoppingIL (Nov 2026): a pre-order size gets its line property
    add([it], {
      source: 'set', open: false, fresh: true,   // the picker starts again from the line's variant
      // Afterwards: stay in the picker while the set still needs more; once it's complete, land on the line's "+".
      focusAfter: function () {
        delete setPending[pid];
        var b2 = q('[data-rb-focus="setadd:' + pid + '"]');
        if (b2) return b2;
        var li = q('.rb-cart__line[data-product="' + pid + '"]');
        return li ? q('[data-rb-qty="1"]', li) : null;
      }
    }).then(function () {
      delete setPending[pid];
      var b4 = q('[data-rb-focus="setadd:' + pid + '"]');
      if (b4) { b4.disabled = false; b4.classList.remove('is-loading'); }
      say(S.setAdded || S.added);
    }, function (e) {
      delete setPending[pid];
      var b3 = q('[data-rb-focus="setadd:' + pid + '"]') || btn;
      b3.disabled = false;
      b3.classList.remove('is-loading');
      var box3 = b3.closest('[data-rb-setbox]');
      msg(box3 ? q('[data-rb-set-err]', box3) : err, (e && (e.description || e.message)) || S.err);
    });
  }

  // F13 (sprint 2): "1 more = set of 3 + free delivery" adds one more of this line's own item (same size and colour).
  // setQty() is the line's "+": it checks the stock limit and shows "only N available" itself. Sent at once, not after
  // the 350 ms "+" debounce (one tap = one item; the line is busy, so no second tap, until the cart repaints).
  function setOne(btn) {
    var li = btn.closest('.rb-cart__line');
    // is-busy only blocks pointer taps (CSS); a repeated Enter / Space on the focused hint must not add a second item
    if (!li || li.classList.contains('is-busy')) return;
    var id = ident(li);
    var before = pendingQty[id] != null ? pendingQty[id] : Number(li.getAttribute('data-qty'));
    setQty(id, 1);
    var want = pendingQty[id];
    if (want == null || want === before) return;   // at the stock limit (message shown); a pending "+" keeps its timer
    clearTimeout(qtyTimers[id]);
    sendQty(id).then(function () {
      var l2 = lineEl(id);
      if (l2 && Number(l2.getAttribute('data-qty')) >= want) say(S.setAdded || S.updated);
    });
  }

  function upsellAdd(btn) {
    var card = btn.closest('[data-rb-card]');
    if (!card) return;
    var err = q('[data-rb-card-err]', card);
    var vs = variantsOf(card) || [];
    var sels = selectsOf(card);
    var size = sels.filter(function (s) { return s.hasAttribute('data-rb-size'); })[0];
    if (size && !size.value) {
      size.classList.add('is-missing');
      size.setAttribute('aria-invalid', 'true');
      msg(err, S.needSize);
      size.focus();
      return;
    }
    var v = sels.length ? pick(vs, sels) : vs[0];
    if (!v || !v.a) { msg(err, S.soldOpt); return; }
    msg(err, '');
    btn.disabled = true;
    btn.classList.add('is-loading');
    var handle = card.getAttribute('data-handle');
    var it = { id: v.id, quantity: 1 };
    if (v.p && poOn()) it.properties = poProps();   // ShoppingIL (Nov 2026): a pre-order size gets its line property
    add([it], { source: 'upsell' }).then(function () {
      var r = root();
      var prev = r ? r.getAttribute('data-upsell-attr') : '';
      var val = prev ? prev + ',' + handle : handle;
      // Order attribute, not a line property (a property would split identical items into two lines).
      queue(function () { return post(U.update, { attributes: { rb_upsell: val } }); })
        .then(function () { if (r) r.setAttribute('data-upsell-attr', val); }, function () {});
    }, function (e) {
      btn.disabled = false;
      btn.classList.remove('is-loading');
      msg(err, (e && e.description) || S.err);
    });
  }

  /* ---------- discount codes ---------- */
  function money(cents) { return '₪' + (cents / 100).toFixed(2).replace(/\.00$/, ''); }
  function codeBox(text, ok) {
    var box = document.getElementById('RBCart-CodeMsg'), input = document.getElementById('RBCart-Code');
    msg(box, text, ok);
    if (input) { if (text && !ok) input.setAttribute('aria-invalid', 'true'); else input.removeAttribute('aria-invalid'); }
  }
  // A welcome code entered under its minimum stays on the cart (Shopify applies it by itself once the cart qualifies);
  // the drawer shows it as a "pending" pill until then.
  function pendingPill() {
    var list = q('[data-rb-pills]');
    if (!list) return;
    var old = q('.rb-cart__pill.is-pending', list); if (old) old.remove();
    // ShoppingIL (Nov 2026): WELCOME30 doesn't combine with the sale, so it never "applies by itself over ₪300" then
    if (saleOn()) { ss(PENDING_KEY, null); return; }
    var code = ss(PENDING_KEY);
    var r = root();
    if (!code || !r) return;
    var applied = (r.getAttribute('data-codes') || '').toUpperCase().split(',');
    if (applied.indexOf(code.toUpperCase()) > -1 || r.getAttribute('data-count') === '0') { ss(PENDING_KEY, null); return; }
    var min = Number(r.getAttribute('data-welcome-min')), sub = Number(r.getAttribute('data-subtotal'));
    var li = document.createElement('li');
    li.className = 'rb-cart__pill is-pending';
    li.innerHTML = '<span dir="ltr"></span><span class="rb-cart__pill-note"></span>' +
      '<button type="button" class="rb-cart__pill-x" data-rb-focus="pill:' + code.replace(/"/g, '') + '"><svg width="10" height="10" viewBox="0 0 14 14" aria-hidden="true" focusable="false"><path d="M1 1l12 12M13 1L1 13" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></button>';
    li.firstChild.textContent = code;
    li.children[1].textContent = S.codePending.replace('[min]', money(min)).replace('[left]', money(Math.max(0, min - sub)));
    var x = li.querySelector('button');
    x.setAttribute('data-rb-code-remove', code);
    x.setAttribute('aria-label', S.codeRm.replace('[code]', code));
    list.appendChild(li);
  }
  function applyCode(raw) {
    var input = document.getElementById('RBCart-Code');
    var code = String(raw != null ? raw : (input ? input.value : '')).replace(/[​-‏‪-‮⁦-⁩﻿]/g, '').trim();
    if (!code) { codeBox(S.codeEmpty); if (input) input.focus(); return Promise.resolve(); }
    var up = code.toUpperCase();
    codeBox(S.checking, true);
    var outcome = 'bad';
    return queue(function () {
      // Read the codes from the cart itself (including ones that don't apply yet), right before writing.
      return getCart().then(function (cart) {
        var all = (cart.discount_codes || []).map(function (d) { return d.code; });
        var mine = (cart.discount_codes || []).filter(function (d) { return String(d.code).toUpperCase() === up; })[0];
        if (mine && mine.applicable) { outcome = 'ok'; return null; }
        var list = all.filter(function (c) { return String(c).toUpperCase() !== up; });
        return post(U.update, withSections({ discount: list.concat(code).join(',') })).then(function (res) {
          var hit = (res.discount_codes || []).filter(function (d) { return String(d.code).toUpperCase() === up; })[0];
          if (hit && hit.applicable) { outcome = 'ok'; return res; }
          var r = root();
          var wc = r ? r.getAttribute('data-welcome-code') : '';
          var min = r ? Number(r.getAttribute('data-welcome-min')) : 0;
          // ShoppingIL (Nov 2026): no "applies over ₪300" while the sale is on: the code is just not usable then
          if (wc && !saleOn() && up === wc && res.items_subtotal_price < min) { outcome = 'pending'; return res; }
          // Not usable on this cart: take it back out so it doesn't linger.
          return post(U.update, withSections({ discount: list.join(',') }));
        });
      });
    }).then(function (res) {
      if (outcome === 'pending') ss(PENDING_KEY, code.toUpperCase()); else if (outcome === 'ok') ss(PENDING_KEY, null);
      if (res) paint(res.sections, { source: 'code' });
      var inp = document.getElementById('RBCart-Code');
      if (outcome === 'ok') { if (inp) inp.value = ''; codeBox(S.codeOk, true); return; }
      if (outcome === 'pending') {
        if (inp) inp.value = '';
        var r = root();
        var min = Number(r.getAttribute('data-welcome-min')), sub = Number(r.getAttribute('data-subtotal'));
        codeBox(S.codeWelcome.replace('[code]', code.toUpperCase()).replace('[min]', money(min)).replace('[left]', money(Math.max(0, min - sub))), true);
        return;
      }
      if (inp) { inp.value = code; inp.focus(); }
      codeBox(S.codeBad);
    }, function (e) { codeBox((e && e.description) || S.err); });
  }
  function removeCode(code) {
    var up = String(code).toUpperCase();
    if (ss(PENDING_KEY) === up) ss(PENDING_KEY, null);
    try { document.cookie = 'discount_code=; Max-Age=0; path=/'; } catch (e) {}
    return queue(function () {
      return getCart().then(function (cart) {
        var left = (cart.discount_codes || []).map(function (d) { return d.code; })
          .filter(function (c) { return String(c).toUpperCase() !== up; });
        return post(U.update, withSections({ discount: left.join(',') }));
      });
    }).then(function (res) { paint(res.sections, { status: S.updated, source: 'code' }); }, fail);
  }

  function saveNote(announce) {
    var note = document.getElementById('RBCart-Note');
    if (!note) return;
    var val = note.value;
    queue(function () { return post(U.update, { note: val }); }).then(function () {
      var s = q('[data-rb-note-saved]');
      if (s && announce) { s.textContent = S.saved; setTimeout(function () { s.textContent = ''; }, 1500); }
    }, function () {});
  }

  /* ---------- suggestion arrows ---------- */
  function arrows() {
    var track = q('.rb-cart__cards');
    var prev = q('[data-rb-arrow="prev"]'), next = q('[data-rb-arrow="next"]');
    if (!track || !prev || !next) return;
    var x = Math.abs(track.scrollLeft), maxX = track.scrollWidth - track.clientWidth - 2;
    setDis(prev, x <= 2);
    setDis(next, x >= maxX);
  }
  function scrollCards(dir) {
    var track = q('.rb-cart__cards');
    if (!track) return;
    var rtl = root().getAttribute('dir') === 'rtl';
    var step = track.clientWidth * 0.9 * (dir === 'next' ? 1 : -1) * (rtl ? -1 : 1);
    track.scrollBy({ left: step, behavior: calm() ? 'auto' : 'smooth' });
    setTimeout(arrows, 400);
  }

  /* ---------- checkout ---------- */
  function goCheckout() {
    var f = document.getElementById('RBCart-Form');   // re-read: a repaint replaces the form
    if (f) HTMLFormElement.prototype.submit.call(f);
  }

  /* ---------- wiring ---------- */
  function init() {
    var r = root();
    if (!r) return;
    try { S = JSON.parse((document.getElementById('RBCart-Strings') || {}).textContent || '{}'); } catch (e) { S = {}; }
    S.err = S.err || 'Something went wrong. Please try again.';
    S.soldSuffix = S.soldSuffix || ' – sold out';
    S.max = S.max || 'Only [n] available';
    S.codePending = S.codePending || '';
    S.codeRm = S.codeRm || '[code]';

    if (!customElements.get('rb-cart')) {
      customElements.define('rb-cart', class extends HTMLElement {
        getSectionsToRender() { return [{ id: 'rb-cart' }, { id: 'cart-icon-bubble' }]; }
        setActiveElement(el) { activeEl = el; }
        renderContents(parsed) { paint(parsed && parsed.sections, { status: S.added, source: 'product-form' }); open(activeEl); }
      });
    }
    // Dawn's product form posts to /cart/add and then calls this.cart.renderContents(): hand it our drawer.
    // Earlier window-capture handlers (size guard, set picker) stop the event when they take over.
    window.addEventListener('submit', function (e) {
      var el = root();
      if (!el || isPage() || typeof el.renderContents !== 'function') return;
      var pf = e.target && e.target.closest && e.target.closest('product-form');
      if (pf && pf.cart !== el) pf.cart = el;
    }, true);
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('product-form').then(function () {
        if (isPage()) return;
        document.querySelectorAll('product-form [type="submit"]').forEach(function (b) { b.setAttribute('aria-haspopup', 'dialog'); });
      });
    }
    var icon = document.getElementById('cart-icon-bubble');
    if (icon && !isPage()) {
      icon.setAttribute('role', 'button');
      icon.setAttribute('aria-haspopup', 'dialog');
      icon.setAttribute('aria-controls', 'RBCart-Panel');
      icon.setAttribute('aria-expanded', 'false');
      icon.addEventListener('keydown', function (e) {
        if (e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); open(icon); }
      });
    }

    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var t = e.target;
      if (!t || !t.closest) return;
      var rr = root();
      if (rr && rr.contains(t)) {
        var b;
        if ((b = t.closest('[data-rb-cart-close]'))) { e.preventDefault(); close(); return; }
        if ((b = t.closest('[data-rb-qty]'))) { var li = b.closest('.rb-cart__line'); if (li) setQty(ident(li), Number(b.getAttribute('data-rb-qty'))); return; }
        if ((b = t.closest('[data-rb-remove]'))) { var l2 = b.closest('.rb-cart__line'); if (l2) removeLine(ident(l2)); return; }
        if ((b = t.closest('[data-rb-toggle]'))) {
          var box = document.getElementById(b.getAttribute('aria-controls'));
          if (box) {
            box.hidden = !box.hidden;
            b.setAttribute('aria-expanded', box.hidden ? 'false' : 'true');
            if (!box.hidden) { var f = box.querySelector('input, textarea'); if (f) f.focus(); }
          }
          return;
        }
        if ((b = t.closest('[data-rb-code-apply]'))) { applyCode(); return; }
        if ((b = t.closest('[data-rb-code-remove]'))) { removeCode(b.getAttribute('data-rb-code-remove')); return; }
        if ((b = t.closest('[data-rb-upsell-add]'))) { upsellAdd(b); return; }
        if ((b = t.closest('[data-rb-set-add]'))) { setAdd(b); return; }
        if ((b = t.closest('[data-rb-set-one]'))) { setOne(b); return; }
        if ((b = t.closest('[data-rb-arrow]'))) { if (b.getAttribute('aria-disabled') !== 'true') scrollCards(b.getAttribute('data-rb-arrow')); return; }
        return;
      }
      if (isPage()) return;
      var a = t.closest('a[href]');
      if (!a) return;
      if (a.id === 'cart-icon-bubble' || (a.origin === location.origin && /^\/([a-z]{2}(-[a-z]{2})?\/)?cart\/?$/i.test(a.pathname))) {
        e.preventDefault();
        open(a);
      }
    });
    document.addEventListener('change', function (e) {
      var t = e.target;
      var rr = root();
      if (!rr || !t || !rr.contains(t)) return;
      if (t.matches('select[data-rb-sopt]')) {
        var sb = t.closest('[data-rb-setbox]');
        if (sb) { msg(q('[data-rb-set-err]', sb), ''); settleSet(sb, t); }
        return;
      }
      if (!t.matches('select[data-rb-opt]')) return;
      var li = t.closest('.rb-cart__line');
      if (li) { swapVariant(li, t); return; }
      var card = t.closest('[data-rb-card]');
      if (card) {
        t.classList.remove('is-missing');
        t.removeAttribute('aria-invalid');
        msg(q('[data-rb-card-err]', card), '');
        if (t.hasAttribute('data-rb-size')) settleCard(card); else decorate(card);
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target && e.target.id === 'RBCart-Code') { e.preventDefault(); applyCode(); }
    });
    document.addEventListener('input', function (e) {
      if (e.target && e.target.id === 'RBCart-Note') { clearTimeout(noteTimer); noteTimer = setTimeout(function () { saveNote(false); }, 600); }
    });
    document.addEventListener('focusout', function (e) {
      if (e.target && e.target.id === 'RBCart-Note') { clearTimeout(noteTimer); saveNote(true); }
    });
    document.addEventListener('submit', function (e) {
      if (!e.target || e.target.id !== 'RBCart-Form') return;
      checkoutPending = true;
      var btn = e.target.querySelector('.rb-cart__checkout');
      if (btn) btn.setAttribute('aria-busy', 'true');
      if (busy > 0 || Object.keys(pendingQty).length) {
        // Let the last quantity/code change finish, then go to checkout with the form as it is THEN.
        e.preventDefault();
        Object.keys(pendingQty).forEach(function (k) { clearTimeout(qtyTimers[k]); sendQty(k); });
        chain.then(goCheckout);
      }
    });
    document.addEventListener('scroll', function (e) {
      if (e.target && e.target.classList && e.target.classList.contains('rb-cart__cards')) arrows();
    }, true);
    document.addEventListener('cart:refresh', function () { refresh({ open: true }); });
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) {
        checkoutPending = false;
        qa('.rb-cart__checkout[aria-busy]').forEach(function (b) { b.removeAttribute('aria-busy'); });
        refresh();
      }
    });
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') { hiddenAt = Date.now(); return; }
      if (hiddenAt && Date.now() - hiddenAt > 10000) { stale = true; if (isOpen) refresh(); }
    });
    document.addEventListener('shopify:section:select', function (e) { if (e.detail && e.detail.sectionId === 'rb-cart') open(); });
    document.addEventListener('shopify:section:deselect', function (e) { if (e.detail && e.detail.sectionId === 'rb-cart') close(); });
    document.addEventListener('shopify:section:load', function (e) {
      if (!e.detail || e.detail.sectionId !== 'rb-cart') return;
      if (isOpen) { isOpen = false; open(); }
      decorateAll();
    });

    pendingPill();
    decorateAll();
    // ShoppingIL (Nov 2026): the order note on page load (drawer or /cart), and on /cart after Dawn's repaints
    if (isPage()) watchPage();
    syncShipAttr();
  }

  var api = {
    open: function (trigger) { return open(trigger); },
    close: close,
    toggle: function () { return isOpen ? close() : open(); },
    refresh: refresh,
    render: function (sections, opts) {
      opts = opts || {};
      paint(sections, { status: opts.status || S.added, source: opts.source || 'render' });
      if (opts.open) open();
    },
    add: add,
    change: change,
    applyCode: applyCode,
    removeCode: removeCode
  };
  Object.defineProperty(api, 'isOpen', { get: function () { return isOpen; } });
  window.RBCart = api;
  // Phase-1 compat until the Kazam app is uninstalled (old callers check window.KazamCart).
  if (!window.KazamCart) {
    window.KazamCart = {
      open: api.open, close: api.close,
      refresh: function () { return api.refresh(); },
      get isOpen() { return isOpen; }
    };
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
